import { render, staticRenderFns } from "./PostulationQuick.vue?vue&type=template&id=4d3670fd&scoped=true"
import script from "./PostulationQuick.vue?vue&type=script&lang=ts"
export * from "./PostulationQuick.vue?vue&type=script&lang=ts"
import style0 from "./PostulationQuick.vue?vue&type=style&index=0&id=4d3670fd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3670fd",
  null
  
)

export default component.exports